import { type RefObject, useEffect, useRef, useState } from "react";

const HIDE_DELAY = 500;

export const useHoverWithDelay = (elementRef: RefObject<HTMLElement | null>) => {
  const [isHovered, setIsHovered] = useState(false);
  const unHoverTimeoutRef = useRef(0);

  useEffect(() => {
    if (!elementRef.current) {
      return;
    }

    const element = elementRef.current;

    const onPointerEnter = () => {
      if (unHoverTimeoutRef.current) {
        clearTimeout(unHoverTimeoutRef.current);
      }
      unHoverTimeoutRef.current = 0;

      setIsHovered(true);
    };

    const onPointerLeave = () => {
      if (unHoverTimeoutRef.current) {
        clearTimeout(unHoverTimeoutRef.current);
      }

      unHoverTimeoutRef.current = window.setTimeout(() => {
        setIsHovered(false);
      }, HIDE_DELAY);
    };

    element.addEventListener("pointerenter", onPointerEnter);
    element.addEventListener("pointerleave", onPointerLeave);

    return () => {
      element.removeEventListener("pointerenter", onPointerEnter);
      element.removeEventListener("pointerleave", onPointerLeave);
    };
  }, [elementRef]);

  return isHovered;
};
